const FormKeys = {
  action: `https://docs.google.com/forms/u/3/d/e/1FAIpQLScyeoyC4ucDem4hIbDdHdUd05gNu2M7vAJykqcvYd0q8B9BhQ/formResponse`,
  email: `entry.772873825`,
  subject: `entry.617437226`,
  content: `entry.994337839`,
  corsProxy: `https://radiant-sands-22476.herokuapp.com/`,
};

export default FormKeys;
